import React from 'react';
import { Routes, Route, Link } from 'react-router-dom';
import WheelPage from './pages/WheelPage';
import AdminPage from './pages/AdminPage';

function App() {
  return (
    <div>
      <nav className="bg-gray-800 text-white p-4">
        <ul className="flex space-x-4">
          <li>
            <Link to="/" className="hover:bg-gray-700 px-3 py-2 rounded-md">Çark Sayfası</Link>
          </li>
          <li>
            <Link to="/admin" className="hover:bg-gray-700 px-3 py-2 rounded-md">Yönetim Paneli</Link>
          </li>
        </ul>
      </nav>
      <main>
        <Routes>
          <Route path="/" element={<WheelPage />} />
          <Route path="/admin" element={<AdminPage />} />
        </Routes>
      </main>
    </div>
  );
}

export default App;
